import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import {
  LAMBDATEST_CLEAR_BROWSER_SUBVERSION,
  LAMBDATEST_TEST_DETAIL_LOADING,
  LAMBDATEST_TEST_DETAIL_SUCCESS,
  LAMBDATEST_TEST_DETAIL_FAILED,
  LAMBDATEST_TEST_DETAIL_CLEAR,
  LAMBDATEST_TEST_DETAIL_CURRENT_FETCH,
  LAMBDATEST_TEST_DETAIL_SILENT_LOADING,
  LAMBDATEST_TEST_DETAIL_HASHMAP_UPDATE,
  LAMBDATEST_PROMO_BANNER_HEIGHT,
  FETCH_SHARE_ID_DETAILS_LOADING,
  FETCH_SHARE_ID_DETAILS_SUCCESS,
  FETCH_SHARE_ID_DETAILS_FAILED,
  FETCH_FLAKY_TEST_DETAILS_LOADING,
  FETCH_FLAKY_TEST_DETAILS_SUCCESS,
  RESET_FLAKY_TEST_DETAILS,
  FETCH_FLAKY_GROUP_DETAILS_LOADING,
  FETCH_FLAKY_GROUP_DETAILS_SILENT_LOADING,
  FETCH_FLAKY_GROUP_DETAILS_SUCCESS,
  FETCH_FLAKY_GROUP_DETAILS_FAILED,
  LAMBDATEST_REMARK_CONTAINER_HEIGHT,
  LAMBDATEST_TEST_RENAME,
  FETCH_DATA_LOCALISATION_SUCCESS,
  FETCH_DATA_LOCALISATION_FAILED,
  UPDATE_TEST_DETAIL_SESSION_ID
} from "../actionTypeConstants/LambdaTestTestDetailConstants";

import {
  LAMBDATEST_HYPERTEST_TASK_DETAIL_LOADING,
  LAMBDATEST_HYPERTEST_TASK_DETAIL_SUCCESS,
  LAMBDATEST_HYPERTEST_TASK_DETAIL_FAILED,
  LAMBDATEST_SET_VIDEO_START_TIMESTAMP
} from "../actionTypeConstants/Automation";

const initialState = {
  testDetailHashMap: {
    data: {},
    error: null,
    loading: true,
    silentLoading: false,
    logs: {}
  },
  hyperExecuteTaskDetails: {
    isLoading: true,
    data: {},
    error: null
  },
  dataLocalisation: [],
  flakyTestDetails: {},
  isFlakyTestDetailsLoading: true,
  flakyGroupDetails: {
    isLoading: false,
    isSilentLoading: false,
    data: {},
    error: null
  },
  sharedDataLoading: true,
  sharedData: [],
  sharedDataError: null,
  sharingFailedErrorMsg: "",
  videoStartTimestamp: null,
  isAccurateVideoStartTimestampAvailable: false,
  browserSubVersion: "",
  promoBannerHeight: 0,
  commandLogRemarkHeight: 280
};

let currentTestFetchID = null;
let newTestDetailEntry;

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_TEST_DETAIL_CURRENT_FETCH:
      currentTestFetchID = action.testID;
      if (
        state.testDetailHashMap &&
        currentTestFetchID in state.testDetailHashMap
      ) {
        return {
          ...state
        };
      } else {
        newTestDetailEntry = {};
        newTestDetailEntry[currentTestFetchID] = {
          loading: false,
          data: null,
          error: null
        };
        return {
          ...state,
          testDetailHashMap: {
            ...state.testDetailHashMap,
            ...newTestDetailEntry
          }
        };
      }

    case LAMBDATEST_TEST_DETAIL_LOADING:
      return {
        ...state,
        testDetailHashMap: {
          ...state.testDetailHashMap,
          loading: true
        }
      };
    case LAMBDATEST_TEST_DETAIL_SILENT_LOADING:
      return {
        ...state,
        testDetailHashMap: {
          ...state.testDetailHashMap,
          loading: false,
          silentLoading: true
        }
      };

    case LAMBDATEST_TEST_DETAIL_SUCCESS:
      return {
        ...state,
        testDetailHashMap: {
          ...state.testDetailHashMap,
          data: action.result.data,
          loading: false,
          silentLoading: false,
          errorMsg: "",
          error: null
        }
      };

    case LAMBDATEST_TEST_DETAIL_FAILED:
      let errorMsg = get(action, ["error", "response", "data", "message"], "");
      const status = get(action, ["error", "response", "status"], "");
      // Reset test data incase API has been cancelled.
      if (action.error.message === "api request cancelled") {
        return {
          ...state,
          testDetailHashMap: initialState.testDetailHashMap
        };
      }
      return {
        ...state,
        testDetailHashMap: {
          ...state.testDetailHashMap,
          error: action.error,
          loading: false,
          silentLoading: false,
          errorMsg
        }
      };

    case LAMBDATEST_TEST_DETAIL_CLEAR:
      return {
        ...state,
        testDetailHashMap: initialState.testDetailHashMap
      };

    case LAMBDATEST_SET_VIDEO_START_TIMESTAMP: {
      return {
        ...state,
        testDetailHashMap: {
          ...state.testDetailHashMap,
          data: {
            ...state.testDetailHashMap.data,
            videoStartTimestamp: action.payload.timestamp,
            isAccurateVideoStartTimestampAvailable: action.payload.isAccurate
          }
        },
        videoStartTimestamp: action.payload.timestamp,
        isAccurateVideoStartTimestampAvailable: action.payload.isAccurate
      };
    }

    case LAMBDATEST_CLEAR_BROWSER_SUBVERSION: {
      return {
        ...state,
        browserSubVersion: ""
      };
    }

    case LAMBDATEST_PROMO_BANNER_HEIGHT: {
      return {
        ...state,
        promoBannerHeight: action.payload
      };
    }

    case LAMBDATEST_REMARK_CONTAINER_HEIGHT: {
      return {
        ...state,
        commandLogRemarkHeight: action.payload
      };
    }

    case LAMBDATEST_HYPERTEST_TASK_DETAIL_LOADING: {
      return {
        ...state,
        hyperExecuteTaskDetails: {
          isLoading: true,
          error: null
        }
      };
    }

    case LAMBDATEST_HYPERTEST_TASK_DETAIL_SUCCESS: {
      return {
        ...state,
        hyperExecuteTaskDetails: {
          isLoading: false,
          data: get(action, ["result", "data", "data"], {}),
          error: null
        }
      };
    }

    case LAMBDATEST_HYPERTEST_TASK_DETAIL_FAILED: {
      return {
        ...state,
        hyperExecuteTaskDetails: {
          isLoading: false,
          error: action.error
        }
      };
    }

    case LAMBDATEST_TEST_DETAIL_HASHMAP_UPDATE: {
      const updatedData = action.payload;
      const shouldUpdateName = Object.keys(updatedData).includes("name");
      const nameObj = {};
      if (shouldUpdateName) {
        nameObj["name"] = updatedData["name"];
      }
      return {
        ...state,
        testDetailHashMap: {
          ...state.testDetailHashMap,
          data: {
            ...state.testDetailHashMap.data,
            endedAt: updatedData.endedAt,
            startedAt: updatedData.startedAt,
            status: updatedData.status,
            statusInd: updatedData.statusInd,
            // Name may OR may not be present in the BE response. Setting it conditionally.
            ...nameObj
          }
        }
      };
    }

    case FETCH_SHARE_ID_DETAILS_LOADING: {
      return {
        ...state,
        sharedDataLoading: true
      };
    }
    case FETCH_SHARE_ID_DETAILS_SUCCESS: {
      return {
        ...state,
        sharedData: action.result.data,
        sharedDataLoading: false,
        sharedDataError: null
      };
    }
    case FETCH_SHARE_ID_DETAILS_FAILED: {
      const errorMsg = get(
        action,
        ["error", "response", "data", "message"],
        ""
      );
      return {
        ...state,
        sharedData: [],
        sharedDataLoading: false,
        sharedDataError: action.error,
        sharingFailedErrorMsg: errorMsg
      };
    }

    case FETCH_FLAKY_TEST_DETAILS_LOADING: {
      return {
        ...state,
        flakyTestDetails: {},
        isFlakyTestDetailsLoading: true
      };
    }

    case FETCH_FLAKY_TEST_DETAILS_SUCCESS: {
      const payload = action.result.data;
      return {
        ...state,
        flakyTestDetails: payload,
        isFlakyTestDetailsLoading: false
      };
    }

    case RESET_FLAKY_TEST_DETAILS: {
      return {
        ...state,
        flakyTestDetails: {}
      };
    }

    case FETCH_FLAKY_GROUP_DETAILS_LOADING: {
      return {
        ...state,
        flakyGroupDetails: {
          ...state.flakyGroupDetails,
          isLoading: true,
          data: {}
        }
      };
    }

    case FETCH_FLAKY_GROUP_DETAILS_SILENT_LOADING: {
      return {
        ...state,
        flakyGroupDetails: {
          ...state.flakyGroupDetails,
          isSilentLoading: true
        }
      };
    }

    case FETCH_FLAKY_GROUP_DETAILS_SUCCESS: {
      const payload = action.result.data;
      let newData = cloneDeep(state.flakyGroupDetails.data);
      // Handle silent loading pagination
      if (isEmpty(newData)) {
        newData = cloneDeep(payload.data);
      } else {
        newData.tests = [
          ...newData.tests,
          ...get(payload, ["data", "tests"], [])
        ];
        newData.total += get(payload, ["data", "total"], 0);
      }
      return {
        ...state,
        flakyGroupDetails: {
          ...state.flakyGroupDetails,
          data: newData,
          isLoading: false,
          isSilentLoading: false,
          error: null
        }
      };
    }

    case FETCH_FLAKY_GROUP_DETAILS_FAILED: {
      return {
        ...state,
        flakyGroupDetails: {
          ...state.flakyGroupDetails,
          isLoading: false,
          isSilentLoading: false,
          error: action.error
        }
      };
    }

    case LAMBDATEST_TEST_RENAME: {
      const updatedName = action.payload;
      return {
        ...state,
        testDetailHashMap: {
          ...state.testDetailHashMap,
          data: {
            ...state.testDetailHashMap.data,
            name: updatedName
          }
        }
      };
    }

    case FETCH_DATA_LOCALISATION_SUCCESS: {
      return {
        ...state,
        dataLocalisation: [...state.dataLocalisation, ...action.result.data]
      };
    }

    case FETCH_DATA_LOCALISATION_FAILED: {
      return {
        ...state,
        dataLocalisation: []
      };
    }

    case UPDATE_TEST_DETAIL_SESSION_ID: {
      const sessionId = action.payload;
      return {
        ...state,
        testDetailHashMap: {
          ...state.testDetailHashMap,
          data: {
            ...state.testDetailHashMap.data,
            session_id: sessionId
          }
        }
      };
    }

    default:
      return state;
  }
}
